// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_2NKzK","avatar":"index_avatar_1A3j0"};